import React from 'react';

import { userService } from '../_services';
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { Container, Row } from 'react-bootstrap';

class RegisterPage_ extends React.Component {
    constructor(props) {
        super(props);
        userService.logout();
        console.log(process.env.NODE_ENV)
        const devMode = process.env.NODE_ENV === 'development'
        this.state = {
            username: devMode ? '829210431' : '',
            code2: devMode ? 2756 : '',
            invoice_no: devMode ? '100339002' : '',
            password: devMode ? '1234' : '',
            password_confirm: devMode ? '1234' : '',
            submitted: false,
            loading: false,
            error: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password, password_confirm, code2, invoice_no } = this.state;

        // stop here if form is invalid
        if (!(username && password && password_confirm && code2 && invoice_no)) {
            return;
        }

        if (password !== password_confirm) {
            return;
        }

        this.setState({ loading: true });
        userService.registerUser(username, code2, invoice_no, password)
            .then(
                user => {
                    const { from } = this.props.location.state || { from: { pathname: "/" } };
                    this.props.history.push(from);
                },
                error => this.setState({ error, loading: false })
            );
    }

    render() {
        const { username, code2, invoice_no, password, password_confirm, submitted, loading, error } = this.state;
        const { t } = this.props;
        return (
            <div className="col-md-6 autoCenter">
                <h2>{t('register')}/{t('reset_password')}</h2>
                <form name="form" onSubmit={this.handleSubmit}>
                    <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                        <label htmlFor="username">{t('user_name')}</label>
                        <input type="text" className="form-control" name="username" value={username} onChange={this.handleChange} />
                        {submitted && !username &&
                            <div className="help-block">{t('user_name')} {t('required')}</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !code2 ? ' has-error' : '')}>
                        <label htmlFor="code2">{t('code2')}</label>
                        <input type="text" className="form-control" name="code2" value={code2} onChange={this.handleChange} />
                        {submitted && !code2 &&
                            <div className="help-block">{t('code2')} {t('required')}</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !invoice_no ? ' has-error' : '')}>
                        <label htmlFor="invoice_no">{t('invoice_number')}</label>
                        <input type="text" className="form-control" name="invoice_no" value={invoice_no} onChange={this.handleChange} />
                        {submitted && !invoice_no &&
                            <div className="help-block">{t('invoice_number')} {t('required')}</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                        <label htmlFor="password">{t('password')}</label>
                        <input type="password" className="form-control" name="password" ref="password" value={password} onChange={this.handleChange} />
                        {submitted && !password &&
                            <div className="help-block">{t('password')} {t('required')}</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && this.state.password !== password_confirm ? ' has-error' : '')}>
                        <label htmlFor="password_confirm">{t('password_confirm')} </label>
                        <input type="password" className="form-control" name="password_confirm" value={password_confirm} onChange={this.handleChange} />
                        {submitted && this.state.password !== password_confirm &&
                            <div className="help-block">{t('password_confirm_mo_match')}</div>
                        }
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary" disabled={loading}>{t('register')}</button>
                        {loading &&
                            <img alt="Loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }
                    </div>
                    {error &&
                        <div className={'alert alert-danger'}>{error}</div>
                    }
                </form>
                <Link to={`/login`} >{t('login')}</Link>
                <Container>
                    <Row>
                        <a href={process.env.REACT_APP_HELP_URL} >{t('help_video')} </a>
                    </Row>
                </Container>
            </div>
        );
    }
}

const RegisterPage = withTranslation()(RegisterPage_);
export { RegisterPage }; 